export default function Loading() {
  return (
    <div className="loading">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
